var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./icon.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7ec4c544\",\"hasScoped\":false,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./icon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/icon.vue
// module id = zmdZ
// module chunks = 2